export default "__VITE_ASSET__DDDTNVx0__"